import { FAIconName, FireflyButton, FireflyIconButton } from '@equip.health/ui';

import { ALERT_STATUS } from '~/lib/constants/providerDashboard.constants';
import { ProviderAlert } from '~/lib/types/providerDashboard';

import { isUnreadAlert } from './alerts.util';

interface AlertActionsProps {
  alert: ProviderAlert;
  isDisabled: boolean;
  isReviewing: boolean;
  onReview: (alert: ProviderAlert) => void;
  onTookAction: (alert: ProviderAlert) => void;
  onDismiss: (alert: ProviderAlert) => void;
}

const AlertActions = ({
  alert,
  isDisabled,
  isReviewing,
  onReview,
  onTookAction,
  onDismiss,
}: AlertActionsProps) => {
  const isUnread = isUnreadAlert(alert);
  const isAcknowledged = alert.status === ALERT_STATUS.ACKNOWLEDGED;

  return (
    <>
      <FireflyButton
        id={`alert-review-${alert.alertId}`}
        isDisabled={isDisabled}
        isLoading={isReviewing}
        onClick={() => onReview(alert)}
        size="small"
        variant={isUnread ? 'secondary' : 'tertiary'}
      >
        {isUnread ? 'View next steps' : 'Review'}
      </FireflyButton>
      {isAcknowledged && (
        <>
          <FireflyIconButton
            ariaLabel="Action taken"
            icon={FAIconName.checkRegular}
            id={`alert-took-action-${alert.alertId}`}
            isDisabled={isDisabled}
            onClick={() => onTookAction(alert)}
            size="small"
            variant="secondary"
          />
          <FireflyIconButton
            ariaLabel="Dismiss alert"
            icon={FAIconName.xmarkLight}
            id={`alert-dismiss-${alert.alertId}`}
            isDisabled={isDisabled}
            onClick={() => onDismiss(alert)}
            size="small"
            variant="secondary"
          />
        </>
      )}
    </>
  );
};

export default AlertActions;
